import { AccessPolicyStatementFilter } from './types';

export const SAFE_METHODS = ['retrieve', 'list'];

/**
 * Create Access Policy Statement filter for Action.
 *
 * @param filterAction action name
 *
 * @example
 * ```ts
 * const filter = createPrincipalFilter(isLoggedIn ? [`role:${user.role}`, `id:${user.id}`]);
 * ```
 *
 * @see https://rsinger86.github.io/drf-access-policy/statement_elements/#action
 */
export const createActionFilter: (filterAction: string) => AccessPolicyStatementFilter =
  (filterAction) =>
  ({ actions }) => {
    const testActions = ['*', filterAction];
    let testPolicyActions = actions;

    if (testPolicyActions.includes('<safe_methods>')) {
      testPolicyActions = [...SAFE_METHODS, ...testPolicyActions];
    }

    return testActions.some((action) => testPolicyActions.includes(action));
  };
